import {
    GET_PEDIDOS_SUCCESS,
    GET_PEDIDOS_FAIL,
    PROCESAR_PEDIDO_SUCCESS,
    PROCESAR_PEDIDO_FAIL
} from './types'
import * as requestsApi from '../../api/requests';

export const call_pedidos = (params) => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await requestsApi.getAllRequests(params);
            if (res.status === 200) {
                dispatch({

                    type: GET_PEDIDOS_SUCCESS,
                    payload: res.data
                });
            } else {

                dispatch({
                    type: GET_PEDIDOS_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: GET_PEDIDOS_FAIL
            });
        }
    }
}

export const procesar_pedido = (pedidoId, nuevoEstado, comentario = '', params = { pageSize: 25, page: 1 }) => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await requestsApi.resolveRequest(pedidoId, nuevoEstado, comentario);

            if (res.status === 200) {
                dispatch({
                    type: PROCESAR_PEDIDO_SUCCESS,
                    payload: res.data
                });

                // Re-fetch the updated list of pedidos, manteniendo los filtros/orden de la tabla
                dispatch(call_pedidos(params));
            } else {
                console.error('Failed to process pedido:', res.data);  // Debug log
                dispatch({
                    type: PROCESAR_PEDIDO_FAIL
                });
            }
        } catch (err) {
            console.error('Error processing pedido:', err.response ? err.response.data : err);  // Debug log
            dispatch({
                type: PROCESAR_PEDIDO_FAIL
            });
        }
    }
}
